import { useEffect } from "react";
import Lenis from "lenis";
import "@/App.css";
import StickyHeader from "@/components/landing/StickyHeader";
import KineticHero from "@/components/landing/KineticHero";
import Categories from "@/components/landing/Categories";
import WhyChooseUs from "@/components/landing/WhyChooseUs";
import HowItWorks from "@/components/landing/HowItWorks";
import Stats from "@/components/landing/Stats";
import Testimonials from "@/components/landing/Testimonials";
import Faq from "@/components/landing/Faq";
import FinalCta from "@/components/landing/FinalCta";
import Footer from "@/components/landing/Footer";
import FloatingCtas from "@/components/landing/FloatingCtas";
import { captureAttribution, getAttribution } from "@/lib/attribution";
import { createLead, getLeads } from "@/lib/leads";

const beaconedLeadIds = new Set();

function postLead(lead, ads) {
  if (!lead || beaconedLeadIds.has(lead.leadId)) return;
  beaconedLeadIds.add(lead.leadId);
  const body = JSON.stringify({
    lead_id: lead.leadId,
    gclid: ads?.gclid || "",
    gbraid: ads?.gbraid || "",
    wbraid: ads?.wbraid || "",
  });
  const blob = new Blob([body], { type: "application/json" });
  if (navigator.sendBeacon && navigator.sendBeacon("/api/lead", blob)) return;
  fetch("/api/lead", {
    method: "POST",
    body,
    headers: { "Content-Type": "application/json" },
    keepalive: true,
  }).catch(() => {});
}

export default function App() {
  useEffect(() => {
    captureAttribution();
    window.getAdsAttribution = getAttribution;
    window.getAdsLeads = getLeads;
  }, []);

  useEffect(() => {
    const onClick = (e) => {
      const link = e.target.closest('a[href^="tel:"], a[href*="wa.me"]');
      if (!link) return;
      if (link.href.includes("wa.me")) {
        e.preventDefault();
        const ads = getAttribution();
        const lead = createLead(ads);
        postLead(lead, ads);
        if (Array.isArray(window.dataLayer)) {
          window.dataLayer.push({
            event: "whatsapp_lead",
            lead_id: lead ? lead.leadId : undefined,
            gclid: ads?.gclid || undefined,
            gbraid: ads?.gbraid || undefined,
            wbraid: ads?.wbraid || undefined,
          });
        }
        if (typeof window.gtag_report_conversion === "function") {
          window.gtag_report_conversion();
        }
        const url = new URL(link.href);
        if (lead) {
          const base = url.searchParams.get("text") || "";
          url.searchParams.set("text", `${base} Lead ID: ${lead.leadId}`);
        }
        window.open(url.toString(), "_blank", "noopener,noreferrer");
        return;
      }
      if (typeof window.gtag_report_conversion === "function") {
        window.gtag_report_conversion();
      }
    };
    document.addEventListener("click", onClick);
    return () => document.removeEventListener("click", onClick);
  }, []);

  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.09, anchors: { offset: -90 } });
    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
    };
  }, []);

  return (
    <div className="overflow-x-clip bg-paper font-body text-ink">
      <StickyHeader />
      <main className="pb-14 md:pb-0">
        <KineticHero />
        <Stats />
        <Categories />
        <WhyChooseUs />
        <HowItWorks />
        <Testimonials />
        <Faq />
        <FinalCta />
      </main>
      <Footer />
      <FloatingCtas />
    </div>
  );
}
